import { defineStore } from 'pinia'

const useCounterStore = defineStore('webtabs', {
    state: () => ({
        editableTabs: [] as { name: string; title: string; content: string; path: string }[],
    }),
    // 也可以定义为
    // state: () => ({ count: 0 })
    actions: {
        addWebTab(tabs: {
            name: string,
            title: string,
            content: string,
            path: string
        }) {
            this.editableTabs.push(tabs)
            // console.log("当前 editableTabs:", this.editableTabs);
        },
        deleteWebTab(tabName: string) {
            this.editableTabs = this.editableTabs.filter(tab => tab.name !== tabName);
            // console.log("删除后 editableTabs:", this.editableTabs);
        },
        findTabByPath(path: string) {
            return this.editableTabs.find(tab => tab.path === path);
        },

    },
})
export default useCounterStore;
// export const useWebTabsStore = defineStore('webtabs', {
//     state: () => ({
//         editableTabs: [] as { name: string; title: string; content: string }[],
//     }),
//     actions: {
//         addWebTab(tab: { name: string; title: string; content: string }) {
//             // 先删除已存在的 tab
//             this.editableTabs = this.editableTabs.filter(item => item.name !== tab.name)
//             // 添加新的 tab
//             this.editableTabs.push(tab)
//         },
//         removeWebTab(tabName: string) {
//             this.editableTabs = this.editableTabs.filter(tab => tab.name !== tabName)
//         },
//     },
// })
